/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Header.css';
import Link from '../Link';
import logoUrl from './icon.png';
import logoUrl2x from './icon@2x.png';
import { isAndroid } from 'react-device-detect';

const APP_STORE_URL = 'https://itunes.apple.com/app/id1471098086';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.holgersindbaek.habitual';

class Header extends React.Component {
  render() {
    const downloadUrl = isAndroid ? GOOGLE_PLAY_URL : APP_STORE_URL;

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.navigation}>
            <Link className={s.brand} to="/">
              <img
                src={logoUrl}
                srcSet={`${logoUrl2x} 2x`}
                width="58"
                height="58"
                alt="Habitual"
              />
              <span className={s.brandText}>Habitual</span>
            </Link>
            <div className={s.download}>
              <a
                target="_blank"
                className={s.downloadLink}
                href={downloadUrl}
              >
                Download
              </a>
              <p className={s.downloadText}>Get started for free</p>
            </div>
          </div>
        </div>
        <div className={s.bottomBorder} />
      </div>
    );
  }
}

export default withStyles(s)(Header);
